import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { retrieveGeoLocation } from "src/services/geoLocalization";

export type VisitorState = {
  location: {
    country?: string;
    city?: string;
  };
};

export const getLocation = createAsyncThunk("visitor/getLocation", async () => {
  const { country, city } = await retrieveGeoLocation();
  return { country, city };
});

const initialState: VisitorState = {
  location: {},
};

export const visitorSlice = createSlice({
  name: "visitor",
  initialState,
  reducers: {
    setVisitorLocation: (
      state,
      action: PayloadAction<Partial<VisitorState["location"]>>
    ) => {
      state.location = { ...state.location, ...action.payload };
    },
  },
  extraReducers: {
    [getLocation.fulfilled.type]: (
      state,
      action: PayloadAction<Partial<VisitorState["location"]>>
    ) => {
      state.location = { ...state.location, ...action.payload };
    },
  },
});

export const { setVisitorLocation } = visitorSlice.actions;

export const visitorReducer = visitorSlice.reducer;
